import { interpolateBlockParam } from '@packages/compose/registry';
import type { FormFetch } from '../types/schema';

/** Stable key for lifecycle fetch effects — any resolved fetch param change retriggers load. */
export function buildFetchTriggerKey(
  fetch: Pick<FormFetch, 'actionId' | 'params'> | null | undefined,
  params?: Record<string, string>,
  meta?: Record<string, unknown>,
): string {
  if (!fetch?.actionId) return '';
  const resolved: Record<string, unknown> = {};
  if (fetch.params) {
    for (const [key, value] of Object.entries(fetch.params)) {
      resolved[key] = interpolateBlockParam(value, params, meta);
    }
  }
  const keys = Object.keys(resolved).sort();
  const payload = keys.map((k) => `${k}=${String(resolved[k] ?? '')}`).join('&');
  return `${fetch.actionId}|${payload}`;
}
